module.exports = __webpack_public_path__ + "img/map_citygid_ru.3274c2fe.jpg";